<script setup lang="ts">
import type { FieldSchema } from '../../../types';

defineOptions({ inheritAttrs: false });

defineProps<{
  field?: FieldSchema;
  label?: string;
}>();
</script>

<template>
  <h2 class="mt-3 w-full text-base font-semibold text-gray-600">
    {{ field?.label || label }}
  </h2>
</template>
